import { z } from "zod";

export const ANALYTICS_PRESETS = ["7d", "30d", "12m"] as const;

export type AnalyticsPreset = (typeof ANALYTICS_PRESETS)[number];

export const analyticsRangeQuerySchema = z
	.object({
		preset: z.enum(ANALYTICS_PRESETS).optional(),
		from: z.iso.datetime().optional(),
		to: z.iso.datetime().optional(),
	})
	.refine((value) => value.preset !== undefined || (value.from !== undefined && value.to !== undefined), {
		message: "Either preset or both from and to must be provided",
	});

export type AnalyticsRangeQuery = z.infer<typeof analyticsRangeQuerySchema>;

export interface ResolvedAnalyticsRange {
	from: Date;
	to: Date;
}

export const resolveAnalyticsRange = (input: AnalyticsRangeQuery): ResolvedAnalyticsRange => {
	const to = input.to ? new Date(input.to) : new Date();
	if (input.from && input.to) {
		return { from: new Date(input.from), to };
	}
	const from = new Date(to);
	switch (input.preset) {
		case "7d":
			from.setUTCDate(from.getUTCDate() - 7);
			break;
		case "30d":
			from.setUTCDate(from.getUTCDate() - 30);
			break;
		default:
			from.setUTCMonth(from.getUTCMonth() - 12);
			break;
	}
	return { from, to };
};
